import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AiAppDetailSectionPage } from "@/features/ai-apps/detail/ai-app-detail-section-page";

const aiAppAgentsSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(10),
  q: z.string().optional().catch(undefined),
  agentType: z.string().optional().catch(undefined),
  source: z.string().optional().catch(undefined),
  permissionState: z
    .enum(["over_permissioned", "within_policy"])
    .optional()
    .catch(undefined),
  agentId: z.string().optional().catch(undefined),
  trace: z.coerce.boolean().optional().catch(undefined),
  traceView: z.enum(["timeline", "hierarchy", "table"]).optional().catch(undefined),
  conversationId: z.string().optional().catch(undefined),
  traceId: z.string().optional().catch(undefined),
  spanId: z.string().optional().catch(undefined),
  evaluatorResultId: z.string().optional().catch(undefined),
  findingId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/ai-apps/$appId/agents")({
  component: () => <AiAppDetailSectionPage section="agents" />,
  validateSearch: aiAppAgentsSearchSchema,
});
